"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessOwnEnabledStatusToJSON = exports.GetBusinessOwnEnabledStatusFromJSONTyped = exports.GetBusinessOwnEnabledStatusFromJSON = exports.GetBusinessOwnEnabledStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetBusinessOwnEnabledStatus;
(function (GetBusinessOwnEnabledStatus) {
    GetBusinessOwnEnabledStatus["ENABLED"] = "ENABLED";
    GetBusinessOwnEnabledStatus["DISABLED"] = "DISABLED";
})(GetBusinessOwnEnabledStatus = exports.GetBusinessOwnEnabledStatus || (exports.GetBusinessOwnEnabledStatus = {}));
function GetBusinessOwnEnabledStatusFromJSON(json) {
    return GetBusinessOwnEnabledStatusFromJSONTyped(json, false);
}
exports.GetBusinessOwnEnabledStatusFromJSON = GetBusinessOwnEnabledStatusFromJSON;
function GetBusinessOwnEnabledStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetBusinessOwnEnabledStatusFromJSONTyped = GetBusinessOwnEnabledStatusFromJSONTyped;
function GetBusinessOwnEnabledStatusToJSON(value) {
    return value;
}
exports.GetBusinessOwnEnabledStatusToJSON = GetBusinessOwnEnabledStatusToJSON;
